import { useQuery } from "@tanstack/react-query";
import { fetchDashboardDates } from "@/api/dashboard";

export function useDashboardDates() {
  return useQuery({
    queryKey: ["dashboard", "dates"],
    queryFn: fetchDashboardDates,
    // Upcoming dates shift over time — refetch on every navigation into the dashboard.
    refetchOnMount: "always",
  });
}
